import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { useSpring, animated } from 'react-spring';
import { Waypoint } from 'react-waypoint';
import styled from 'styled-components';
import { transparentize } from 'polished';
import Image from 'ui/components/Image';
import Text from 'ui/components/Text';
import theme from 'styles/theme';
import salesforcePlug2x from 'resources/img/salesforcePlug2x.png';
import salesforcePlugHeader2x from 'resources/img/salesforcePlugHeader2x.png';

const PlugContainer = styled.div`
  overflow: hidden;
  padding: 70px 0 110px;
  @media only screen and (max-width: ${p => p.theme.breakpoints.sm - 1}px) {
    padding: 60px 0;
    button {
      text-align: center;
    }
  }
`;

const PlugWrppaer = styled.div`
  margin: auto;
  display: flex;
  align-items: center;
  padding: 0 20px;
  &&& {
    max-width: 1120px;
  }

  @media only screen and (max-width: ${p => p.theme.breakpoints.md - 1}px) {
    justify-content: center;
    flex-direction: column;
  }
`;

const PlugContentWrapper = styled(animated.div)`
  display: flex;
  align-items: center;
  height: 100%;
  padding-bottom: 2rem;
  &&& {
    ${p => p.paddingRight && `padding-right:${p.paddingRight}`}
    ${p => p.paddingLeft && `padding-left:${p.paddingLeft}`}
  }

  @media only screen and (max-width: ${p => p.theme.breakpoints.lg - 1}px) {
      &&& {
        padding: 0
      }
    }

  @media only screen and (max-width: ${p => p.theme.breakpoints.md - 1}px) {
    &&& {
      padding: 0
    }
  }

  @media only screen and (max-width: ${p => p.theme.breakpoints.sm - 1}px) {
    display: block;
    height: 100%;
    &&& {
      padding: 0;
    }

    div > div {
      justify-content: left;
    }
  }
`;

const ColorText = styled.span`
  &&& {
      color: ${p => p.color}
  }
`;

const PlugAnimatedImg = styled(animated.img)`
  width: 100%;
  max-width: 624px;
`;

const PlugHeader = styled.img`
  display: block;
  max-width: 355px;
  max-height: 84px;
  margin: auto;
  margin-bottom: 60px; 

  @media only screen and (max-width: ${p => p.theme.breakpoints.md - 1}px) {
    max-width: 300px;
    max-height: 38px;
  }
`;

const Plug = props => {
    return (
        <Waypoint
            scrollableAncestor={window}
            topOffset="10%"
            bottomOffset="35%"
        >
            <PlugContainer>
                <PlugHeader src={salesforcePlugHeader2x} />
                <PlugWrppaer>
                    <PlugAnimatedImg src={salesforcePlug2x} />
                    <PlugContentWrapper paddingLeft="3rem" >
                        <div>
                            <Text fontSize="30px" fontWeight={700} textAlign="left" smMarginTop="60px" maxWidth="312px" marginBottom="30px">
                                <ColorText color={theme.palette.blue.three}>Route qualified buyers on your website to sales and power live conversations</ColorText>
                            </Text>
                            <Text fontSize="14px" fontWeight={400} textAlign="left" mdMarginTop="30px" smMarginTop="30px" marginBottom="12px" color="#757575" maxWidth="312px">
                            Instead of web forms and follow-ups, connect your hottest leads on site to your sales team instantly—and do so based on your Salesforce configuration.
                            </Text>
                        </div>
                    </PlugContentWrapper>
                </PlugWrppaer>
                <Text fontSize="40px" fontWeight={700} textAlign="center" marginTop="40px" mdMarginTop="60px" smMarginTop="70px" marginBottom="12px">
                  <span>Results</span>
                </Text>
                <Text fontSize="22px" color="#191919" textAlign="center" >
                New leads and opportunities created by Insent and tracked in <ColorText color={theme.palette.blue.three}>Salesforce.</ColorText>
                </Text>
            </PlugContainer>
        </Waypoint>
    );
};

Plug.propTypes = {};

export default Plug;
